import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { AppEnum } from 'src/app/appenum';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  secretKey = 'DigitalEyesFBAllianceins';

  constructor(public _appenum: AppEnum) {}

  hashValueConversion(value: any) {
    var hash = CryptoJS.MD5(value);
    return hash;
  }

  localstorageEncrypt(key: string, value: any) {
    var encryptedKey = this.encrypt(key);
    var encryptedValue = this.encrypt(value);
    return localStorage.setItem(encryptedKey, encryptedValue);
  }

  localstorageDecrypt(key: string) {
    var encryptedKey = this.encrypt(key);
    return localStorage.getItem(encryptedKey);
  }

  sessionstorageEncrypt(key: string, value: any) {
    var encryptedKey = this.encrypt(key);
    var encryptedValue = this.encrypt(value);
    return sessionStorage.setItem(encryptedKey, encryptedValue);
  }

  sessionstorageDecrypt(key: string) {
    var encryptedKey = this.encrypt(key);
    return sessionStorage.getItem(encryptedKey);
  }

  encrypt(value: string) {
    value = !value ? '' : value;
    var key = CryptoJS.enc.Utf8.parse(this.secretKey);
    var iv = CryptoJS.enc.Utf8.parse(this.secretKey);
    var encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(value.toString()),
      key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return encrypted.toString();
  }

  decrypt(value) {
    value = !value ? '' : value;
    var key = CryptoJS.enc.Utf8.parse(this.secretKey);
    var iv = CryptoJS.enc.Utf8.parse(this.secretKey);
    var decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
